export type MenuItemIndex = {
  _id: string
  name: string
  isActive: boolean
  isHot: boolean | null
  dietaries: string[]
  allergens: string[]
  image: string | null
  price: number
  priceCustomerFacing: number
  priceExTax: number
  priceCustomerFacingExTax: number
  taxRate: number
  taxValue: number
  categoryIdArray: number[] | null
  position: number | null
  isPrivate: boolean
  privateAccessAccountIdArray: number[] | null
  activeFrom: string | null
  activeTo: string | null
  variationId: string
  servings: number
  minQty: number
  _isIndexOnly: true
}

export const isMenuItemIndex = (item: unknown): item is MenuItemIndex => {
  return (
    typeof item === 'object' &&
    item !== null &&
    '_isIndexOnly' in item &&
    (item as MenuItemIndex)._isIndexOnly === true
  )
}
